/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.searchPosts'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  q: /*#__PURE__*/ l.string(),
  sort: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.string<{ knownValues: ['top', 'latest'] }>(),
      'latest',
    ),
  ),
  since: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  until: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  mentions: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  ),
  author: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  ),
  lang: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'language' }),
  ),
  domain: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  url: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
  tag: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    ),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      25,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  hitsTotal: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  posts: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<FeedDefs.PostView>((() => FeedDefs.postView) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Find posts matching search criteria, returning views of those posts. Note that this API endpoint may require authentication (eg, not public) for some service providers and implementations. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['BadQueryString'])

export { main }

export const $lxm = $nsid
